import {useMutation} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {
  ProductionStepMaterialConditionFormParsed,
  ProductionStepMutation,
  ProductionStepMutationErrorFunction,
  productionStepMutationErrorHandler,
  ProductionStepProp,
} from './production-step.models';
import {useProductionStepMaterialListInvalidation} from './use-production-step-material-list-invalidation';
import Axios from 'axios';

export function useProductionStepMaterialCreateMutation(
  props: ProductionStepProp,
): ProductionStepMutation {
  const {invalidateList} = useProductionStepMaterialListInvalidation(props);
  const {mutate, isPending} = useMutation({
    mutationFn: (form: ProductionStepMaterialConditionFormParsed) =>
      AxiosHttpClient.postNullable<void>(
        `${environment.apiv4uri}article/config/production/step/${
          props.productionStepId
        }/material/condition`,
        form),
    onSuccess: () => {
      invalidateList();
    },
  });

  return {
    isPending,
    mutate: (
      form: ProductionStepMaterialConditionFormParsed,
      errors: ProductionStepMutationErrorFunction,
    ) => mutate(form, {
      onSuccess: () => {
        errors(null);
      },
      onError: (e) => {
        if (Axios.isAxiosError(e)) {
          errors(productionStepMutationErrorHandler(e.response.status, e.response.data?.errors));
        }
      },
    }),
  };
}
